import React, { useState, useEffect, useRef, useMemo } from "react";
import "../css/campaign.scss";
import { useNavigate } from "react-router-dom";
import QuickShareModal from "./QuickShareModal";
import { getFullDonationUrl } from "../utils/urlUtils";
import { BASE_URL, LIST_URL } from "../constans/ApiEndpointConstants";
import { PixelWithEvent } from "./common/PixelWithEvent ";
import * as FacebookAPI from "../apis/FacebookAPI";
import { getOrderList } from "../apis/GetOrderList";
import Cookies from "js-cookie";
import StoryPage from "./StoryPage";
import {
  campaignData,
  enrichDonationsWithRandomTime,
} from "../Datas/campaignData";

class SeededRandom {
  constructor(seed) {
    this.seed = (Number(seed) || 123456789) % 2147483647;
    if (this.seed <= 0) this.seed += 2147483646;
  }

  next() {
    this.seed = (this.seed * 16807) % 2147483647;
    return (this.seed - 1) / 2147483646;
  }
}

const CampaignPage = ({ detailsData }) => {
  const { donationsNewest: initialDonationsNewest } = campaignData;

  const {
    title,
    name: creator,
    raised,
    goal,
    organizeList: organizer,
    createTime,
    image,
    supportList,
    avatar,
  } = detailsData;

  // 给图片加上前缀
  const resolveUrl = (raw) => {
    if (!raw) return "";
    if (/^https?:\/\//i.test(raw) || raw.startsWith("data:")) return raw;
    return `${LIST_URL.replace(/\/$/, "")}/${String(raw).replace(/^\//, "")}`;
  };

  //组织者
  const organizerObj = (() => {
    if (Array.isArray(organizer) && organizer.length > 0) {
      const firstSection = organizer[0];
      const firstItem = firstSection?.list?.[0];
      if (firstItem) {
        return {
          name: firstItem.name || "",
          role: firstItem.role || "",
          location: firstItem.address || "",
          img: resolveUrl(firstItem.avatar || ""),
        };
      }
    }

    if (
      organizer &&
      typeof organizer === "object" &&
      !Array.isArray(organizer)
    ) {
      return {
        name: organizer.name || "",
        role: organizer.role || "",
        location: organizer.location || "",
        img: resolveUrl(organizer.img || ""),
      };
    }

    // fallback to empty fields
    return { name: "", role: "", location: "", img: "" };
  })();

  //支持者
  const supportItems = Array.isArray(supportList)
    ? supportList
    : Array.isArray(supportList?.list)
    ? supportList.list
    : [];

  // helper: 将可能的字符串/格式金额解析为数字（例如 "200000.00", "$200K", "200,000"）
  const parseNumeric = (v) => {
    if (v == null) return 0;
    if (typeof v === "number") return Number.isFinite(v) ? v : 0;
    if (typeof v === "string") {
      // 去掉千位分隔符和货币符号后提取首个数字
      const cleaned = v.replace(/[,¥$€£\s]/g, "");
      const m = cleaned.match(/-?\d+(\.\d+)?/);
      return m ? Number(m[0]) : 0;
    }
    return 0;
  };

  const [donationsView, setDonationsView] = useState("newest");
  const [timeLeft, setTimeLeft] = useState("");
  const [showCopiedToast, setShowCopiedToast] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");
  // 控制是否显示完整页面内容（手机端切换时使用）
  const [showFullPage, setShowFullPage] = useState(true);

  //主页轮博图片（memoized，避免在多个 effect 中触发不必要的重新计算）
  const HERO_SLIDES = useMemo(() => {
    // If backend provides an `image` array, map it to slides
    if (Array.isArray(image) && image.length > 0) {
      const imageSlides = image
        .map((img) => {
          const raw = img?.url || img?.path || img?.src || "";
          if (!raw) return null;

          const lower = String(raw).toLowerCase();
          const looksLikeYoutube = /youtu\.be|youtube\.com/.test(lower);
          // detect common video file extensions (mp4/mov/webm/etc)
          const isVideoFile = /\.(mp4|mov|webm|m4v|ogg|ogv)(\?.*)?$/.test(
            lower
          );

          // handle video/link types (youtube, external video link, or direct video file)
          if (
            img?.type === "link" ||
            img?.type === "video" ||
            looksLikeYoutube ||
            isVideoFile
          ) {
            // detect youtube id and build embed src; otherwise keep raw as url
            const m = String(raw).match(
              /(?:youtu\.be\/|embed\/|v=|\/watch\?v=)([A-Za-z0-9_-]{11})/
            );
            const id = m ? m[1] : null;
            const embedSrc = id ? `https://www.youtube.com/embed/${id}` : raw;
            return {
              // treat explicit video type or direct video file as "video", otherwise "link"
              type: img?.type === "video" || isVideoFile ? "video" : "link",
              url: raw,
              src: embedSrc,
              alt: img?.alt || "Hero video",
            };
          }

          const src =
            /^https?:\/\//i.test(raw) || raw.startsWith("data:")
              ? raw
              : `${LIST_URL.replace(/\/$/, "")}/${raw.replace(/^\//, "")}`;
          return {
            type: "image",
            src,
            alt: img?.alt || "Main image",
          };
        })
        .filter(Boolean);

      return [...imageSlides];
    }
    return [];
  }, [image]);

  // 从 YouTube embed URL 提取 video id（用于海报图）
  const getYouTubeIdFromEmbedUrl = (url) => {
    if (!url || typeof url !== "string") return null;
    // 支持多种 YouTube URL：youtu.be/ID, /watch?v=ID, embed/ID, v=ID
    const m = url.match(
      /(?:youtu\.be\/|embed\/|v=|\/watch\?v=)([A-Za-z0-9_-]{11})/
    );
    return m ? m[1] : null;
  };

  const DONATION_SPOTLIGHT = {
    message: "それぞれの寄付が希望をもたらします。共に変化を起こしましょう。",
    image: process.env.PUBLIC_URL + "/main/main3-1.png",
  };

  const formatTime = (timeValue, type = "hours") => {
    if (typeof timeValue === "string") {
      // 已经有单位，直接返回
      return timeValue;
    }

    if (type === "hours") {
      if (timeValue < 1) {
        const mins = Math.round(timeValue * 60);
        return `${mins} 分前`;
      } else {
        const hrs = Math.round(timeValue);
        return `${hrs} 時間前`;
      }
    }

    if (type === "days") {
      return `${timeValue} 日前`;
    }

    return timeValue;
  };

  // 计算并返回用于显示的时间字符串，支持多种来源和回退顺序
  const computeDonationTime = (donor) => {
    if (!donor) return "";

    // 优先处理数值型 hoursAgo
    if (typeof donor.hoursAgo === "number" && Number.isFinite(donor.hoursAgo)) {
      if (donor.hoursAgo < 24) {
        return formatTime(donor.hoursAgo, "hours");
      }
      // 如果有 daysAgo（可能是数字或字符串），优先使用它
      if (
        typeof donor.daysAgo === "number" ||
        typeof donor.daysAgo === "string"
      ) {
        return formatTime(donor.daysAgo, "days");
      }
      // 回退：把小时转换为天数显示
      return formatTime(donor.hoursAgo / 24, "days");
    }

    // 如果 daysAgo 存在（数字或字符串），尝试解析并规范化单位（例如 "6 days" -> "6 d"）
    if (typeof donor.daysAgo === "number") {
      return formatTime(donor.daysAgo, "days");
    }

    if (typeof donor.daysAgo === "string") {
      const m = donor.daysAgo.match(/(\d+(?:\.\d+)?)(?:\s*(\w+))?/);
      if (m) {
        const val = parseFloat(m[1]);
        const unit = (m[2] || "").toLowerCase();
        // 保持自然单位显示：天/小时/分钟
        if (unit.startsWith("d")) {
          return `${val} 日前`;
        }
        if (unit.startsWith("min")) {
          return `${Math.round(val)} 分前`;
        }
        if (unit.startsWith("hr") || unit.startsWith("hour")) {
          // 不再把小时转换为天，直接显示为小时
          return `${Math.round(val)} 時間前`;
        }
        // 如果没有单位，按天数显示（回退）
        return formatTime(val, "days");
      }
      // 无法解析时回退到原始字符串
      return donor.daysAgo;
    }

    // 如果存在预格式化的 time 字段，尝试规范化单位（例如 "days" -> "d"）
    if (donor.time) {
      if (typeof donor.time === "string") {
        const m = donor.time.match(/(\d+(?:\.\d+)?)\s*(\w+)/);
        if (m) {
          const val = parseFloat(m[1]);
          const unit = m[2].toLowerCase();
          if (unit.startsWith("d")) {
            return `${val} 日前`;
          }
          if (unit.startsWith("hr") || unit.startsWith("hour")) {
            return `${Math.round(val)} 時間前`;
          }
          if (unit.startsWith("min")) {
            return `${Math.round(val)} 分前`;
          }
        }
        // 无法解析时返回原始字符串
        return donor.time;
      }
      return String(donor.time);
    }

    // 如果有 createtime（时间戳或可解析日期），格式化显示
    if (donor.createtime) {
      return formatCreateTimeDisplay(donor.createtime);
    }

    return "";
  };

  const dedupeDonations = (list) => {
    const uniqueMap = new Map();
    list.forEach((donation) => {
      if (!donation) {
        return;
      }
      const key = `${donation.name}-${donation.amount}-${donation.daysAgo}`;
      if (!uniqueMap.has(key)) {
        uniqueMap.set(key, donation);
      }
    });
    return Array.from(uniqueMap.values());
  };

  // Fisher-Yates 洗牌，用于每次更新时随机化捐款顺序
  // Modified to support seeded randomness
  const shuffleArray = (arr, seed = null) => {
    const rng = seed ? new SeededRandom(seed) : null;
    const random = rng ? () => rng.next() : Math.random;

    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(random() * (i + 1));
      const tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  };

  // 将一组 donations 按比例缩放，使它们的金额总和等于 target（保留两位小数）
  const scaleDonationsToTarget = (donations = [], target = 0) => {
    const tgt = Number(target) || 0;
    if (!Array.isArray(donations) || donations.length === 0) return donations;

    // Initialize SeededRandom with target as seed
    // This ensures the distribution is deterministic for a given target amount
    const rng = new SeededRandom(tgt);
    const random = () => rng.next();

    // User defined tiers
    const tier1 = [20, 25, 30, 35, 40, 45, 50, 55]; // Frequent
    const tier2 = [100, 150, 200]; // General
    const tier3 = [500, 1000, 1500, 2000, 5000, 10000]; // Rare (Added 500)

    const count = donations.length;
    // Helper to get random item from array using seeded random
    const getRandom = (arr) => arr[Math.floor(random() * arr.length)];

    // Initialize amounts array
    let currentAmounts = new Array(count).fill(0);
    let assignedIndices = new Set();
    let currentSum = 0;

    // --- Forced Assignment Logic ---
    // Rule: For every 5000 in target:
    // - 1 donation >= 500
    // - 2 donations > 100

    const multiplier = Math.floor(tgt / 5000);

    if (multiplier > 0) {
      const requiredHigh = 1 * multiplier; // >= 500
      const requiredMid = 2 * multiplier; // > 100

      const assignToSlot = (val) => {
        // Find an available slot
        let slot = -1;
        let attempts = 0;
        while (attempts < 100) {
          const r = Math.floor(random() * count);
          if (!assignedIndices.has(r)) {
            slot = r;
            break;
          }
          attempts++;
        }

        // Fallback: Linear scan if random failed
        if (slot === -1) {
          for (let j = 0; j < count; j++) {
            if (!assignedIndices.has(j)) {
              slot = j;
              break;
            }
          }
        }

        // If we found a slot, assign value
        if (slot !== -1) {
          currentAmounts[slot] = val;
          assignedIndices.add(slot);
          currentSum += val;
          return true;
        }
        return false;
      };

      // 1. Assign High (>= 500)
      // Candidates: Tier 3 (all are >= 500)
      // We must ensure that picking a high value doesn't make it impossible to fit other forced donations
      // Min cost for one Mid (>100) is ~150 (from Tier 2: 100, 150, 200 -> >100 are 150, 200)
      const minMidCost = 150;
      const minHighCost = 500;

      for (let k = 0; k < requiredHigh; k++) {
        // Calculate remaining budget constraint
        // We need to reserve space for:
        // - Remaining Highs: (requiredHigh - 1 - k) * minHighCost
        // - All Mids: requiredMid * minMidCost
        const reserved =
          requiredMid * minMidCost + (requiredHigh - 1 - k) * minHighCost;
        const maxAllowed = Math.max(minHighCost, tgt - currentSum - reserved);

        const candidates = tier3.filter((v) => v <= maxAllowed);

        if (candidates.length > 0) {
          const val = getRandom(candidates);
          assignToSlot(val);
        }
      }

      // 2. Assign Mid (> 100)
      // Candidates: Filter Tier 2 for > 100 (150, 200)
      const baseMidCandidates = tier2.filter((v) => v > 100);

      for (let k = 0; k < requiredMid; k++) {
        // Reserve for remaining Mids
        const reserved = (requiredMid - 1 - k) * minMidCost;
        const maxAllowed = Math.max(minMidCost, tgt - currentSum - reserved);

        const candidates = baseMidCandidates.filter((v) => v <= maxAllowed);

        if (candidates.length > 0) {
          const val = getRandom(candidates);
          assignToSlot(val);
        }
      }
    }

    // --- Fill Remaining ---
    // Fill everyone else with Tier 1 initially
    for (let i = 0; i < count; i++) {
      if (!assignedIndices.has(i)) {
        const val = getRandom(tier1);
        currentAmounts[i] = val;
        currentSum += val;
      }
    }

    let diff = tgt - currentSum;

    // Handle Overshoot
    if (diff < 0) {
      // Identify indices that were NOT forced (Tier 1s)
      const tier1Indices = [];
      for (let i = 0; i < count; i++) {
        if (!assignedIndices.has(i)) tier1Indices.push(i);
      }

      // Shuffle them to remove randomly
      for (let i = tier1Indices.length - 1; i > 0; i--) {
        const j = Math.floor(random() * (i + 1));
        [tier1Indices[i], tier1Indices[j]] = [tier1Indices[j], tier1Indices[i]];
      }

      while (diff < 0 && tier1Indices.length > 0) {
        const idxToRemove = tier1Indices.pop();
        const val = currentAmounts[idxToRemove];
        currentAmounts[idxToRemove] = 0; // Mark for removal
        currentSum -= val;
        diff += val;
      }
    }

    // Handle Undershoot (Surplus)
    let safety = 0;
    const maxIterations = count * 50;

    while (diff >= 5 && safety < maxIterations) {
      safety++;
      const idx = Math.floor(random() * count);

      // Skip if this slot was removed (0)
      if (currentAmounts[idx] === 0) continue;

      const currentVal = currentAmounts[idx];
      let potentialUpgrade = null;
      const r = random();

      if (diff >= 1000 && r < 0.15) {
        const candidates = tier3.filter(
          (v) => v - currentVal <= diff && v > currentVal
        );
        if (candidates.length > 0) potentialUpgrade = getRandom(candidates);
      }

      if (!potentialUpgrade && diff >= 100 && r < 0.35) {
        const candidates = tier2.filter(
          (v) => v - currentVal <= diff && v > currentVal
        );
        if (candidates.length > 0) potentialUpgrade = getRandom(candidates);
      }

      if (!potentialUpgrade) {
        const candidates = tier1.filter(
          (v) => v - currentVal <= diff && v > currentVal
        );
        if (candidates.length > 0) potentialUpgrade = getRandom(candidates);
      }

      if (potentialUpgrade) {
        const cost = potentialUpgrade - currentVal;
        currentAmounts[idx] = potentialUpgrade;
        diff -= cost;
      } else {
        if (diff < 5) break;
      }
    }

    // Map result and shuffle
    const finalDonations = donations
      .map((d, i) => ({ ...d, amount: currentAmounts[i] }))
      .filter((d) => d.amount > 0);

    for (let i = finalDonations.length - 1; i > 0; i--) {
      const j = Math.floor(random() * (i + 1));
      [finalDonations[i], finalDonations[j]] = [
        finalDonations[j],
        finalDonations[i],
      ];
    }

    return finalDonations;
  };

  // 本地（动态）捐款列表 —— 用于显示并参与随机化/轮训
  // 限制轮训池大小，避免对数千条记录做全量轮训
  const computeRotationSampleSize = (goalValue) => {
    const g = parseNumeric(goalValue);
    // fallback
    if (!g || g <= 0) return 25;

    //根据goal限制捐款列表总数
    const bands = [
      { gMin: 0, gMax: 999, sizeMin: 20, sizeMax: 50 },
      { gMin: 1000, gMax: 4999, sizeMin: 150, sizeMax: 250 },
      { gMin: 5000, gMax: 19999, sizeMin: 250, sizeMax: 400 },
      { gMin: 20000, gMax: 99999, sizeMin: 400, sizeMax: 800 },
      {
        gMin: 10000,
        gMax: Number.POSITIVE_INFINITY,
        sizeMin: 2000,
      },
    ];

    const band = bands.find((b) => g >= b.gMin && g <= b.gMax) || bands[0];

    if (!isFinite(band.gMax)) {
      return Math.round((band.sizeMin + band.sizeMax) / 2);
    }

    const t = Math.min(
      Math.max((g - band.gMin) / (band.gMax - band.gMin), 0),
      1
    );
    const size = Math.round(band.sizeMin + t * (band.sizeMax - band.sizeMin));
    return size;
  };

  const initialDynamicFull = enrichDonationsWithRandomTime(
    initialDonationsNewest || [],
    createTime
  );
  const initialSampleSize = computeRotationSampleSize(goal);

  // Use raised amount as seed for deterministic shuffle
  const seed = parseNumeric(raised);

  let initialDynamicSampled = dedupeDonations(
    shuffleArray([...initialDynamicFull], seed)
  ).slice(0, initialSampleSize);
  // 将初始样本按 raised 缩放，使金额总和等于 raised（不包括 apiDonationsTotal）
  initialDynamicSampled = scaleDonationsToTarget(
    initialDynamicSampled,
    parseNumeric(raised)
  );

  const [dynamicDonations, setDynamicDonations] = useState(
    () => initialDynamicSampled
  );

  // API 拉取的捐款（固定显示在最上面，不参与随机化）
  const [apiDonationsList, setApiDonationsList] = useState([]);

  // 存储从 API 获取的捐款总额
  const [apiDonationsTotal, setApiDonationsTotal] = useState(0);

  // 最终用于渲染的捐款列表：API 列表固定在顶部，后面跟动态列表
  const donationsNewest = useMemo(
    () => [...apiDonationsList, ...dynamicDonations],
    [apiDonationsList, dynamicDonations]
  );

  // 动态计算捐款总额：初始值 + API 捐款总额（确保都是数字）
  const totalRaised = useMemo(() => {
    const base = parseNumeric(raised);
    const apiTotal = parseNumeric(apiDonationsTotal);
    return base + apiTotal;
  }, [raised, apiDonationsTotal]);

  // 随机生成的基础支持者人数（基于ID固定）
  const randomBaseCount = useMemo(() => {
    const seed = detailsData?.id ? Number(detailsData.id) : 12345;
    const rng = new SeededRandom(seed);
    // 生成 100-500 的随机数，模拟基础支持者
    return Math.floor(rng.next() * 401) + 100;
  }, [detailsData?.id]);

  // 动态计算捐款数量
  const donationsCount = apiDonationsList.length + randomBaseCount;

  // 动态计算进度百分比
  const progressPercentage = useMemo(() => {
    const numericGoal = parseNumeric(goal);
    if (!numericGoal || numericGoal <= 0) return 0;
    const percentage = Math.round((totalRaised / numericGoal) * 100);
    return Math.min(percentage, 100); // 最大100%
  }, [totalRaised, goal]);

  // 排序显示Top捐助者
  const donationsTop = useMemo(() => {
    if (!donationsNewest?.length) {
      return [];
    }
    return [...donationsNewest].sort(
      (a, b) => (b.amount ?? 0) - (a.amount ?? 0)
    );
  }, [donationsNewest]);

  const [currentHeroImage, setCurrentHeroImage] = useState(0);
  const carouselRef = useRef(null);

  const formatCurrency = (amount) => {
    const num = Number(amount) || 0;
    return `${num.toLocaleString("en", { maximumFractionDigits: 0 })}`;
  };

  useEffect(() => {
    // 强制滚动到顶部，确保切换到PC端时也是从顶部开始
    window.scrollTo(0, 0);
  }, []); // 仅在组件挂载时执行

  // 监听 activeTab 变化，如果是切换 Tab 导致的重新渲染，也可以考虑滚动
  useEffect(() => {
    if (activeTab === "overview") {
      // 切换回 overview 时，可能需要重置滚动位置或确保显示正常
      // window.scrollTo(0, 0); // 可选：如果希望每次切换 tab 都回滚顶部
    }
  }, [activeTab]);

  useEffect(() => {
    if (!createTime) return;

    const calculateTimeLeft = () => {
      let targetTime;
      // 尝试解析 createTime (支持数字或字符串格式的时间戳)
      if (typeof createTime === "number") {
        targetTime = createTime < 10000000000 ? createTime * 1000 : createTime;
      } else if (typeof createTime === "string") {
        // 尝试解析为数字
        const parsedNum = Number(createTime);
        if (!isNaN(parsedNum)) {
          targetTime = parsedNum < 10000000000 ? parsedNum * 1000 : parsedNum;
        } else {
          // 尝试解析为日期字符串
          targetTime = Date.parse(createTime);
        }
      }

      if (!targetTime || isNaN(targetTime)) return "";

      const now = new Date().getTime();
      const difference = targetTime - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        if (days > 0) {
          return `${days}日`;
        }

        const totalHours = Math.floor(difference / (1000 * 60 * 60));
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const seconds = Math.floor((difference / 1000) % 60);

        return `${totalHours}時間 ${minutes}分 ${seconds}秒`;
      } else {
        return "終了";
      }
    };

    setTimeLeft(calculateTimeLeft());

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [createTime]);

  const navigate = useNavigate();

  // Mobile swipe handlers
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // Minimum swipe distance (in px)
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      setCurrentHeroImage((prev) => (prev + 1) % HERO_SLIDES.length);
    }
    if (isRightSwipe) {
      setCurrentHeroImage(
        (prev) => (prev - 1 + HERO_SLIDES.length) % HERO_SLIDES.length
      );
    }
  };

  //计算时间戳
  const calculateDaysAgo = (timestamp) => {
    if (!timestamp) return "0 mins";

    let ts = Number(timestamp);
    if (Number.isNaN(ts)) return "0 mins";

    // 秒级时间戳转毫秒
    if (ts < 10000000000) ts *= 1000;

    const parsedDate = new Date(ts);
    if (Number.isNaN(parsedDate.getTime())) return "0 mins";

    const diffMs = Date.now() - parsedDate.getTime();
    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffMins < 60) {
      return `${diffMins} 分前`;
    } else if (diffHours < 24) {
      return `${diffHours} 時間前`;
    } else {
      return `${diffDays} 日前`;
    }
  };

  // 格式化 createTime 字段为相对时间并统一单位（days -> d）
  const formatCreateTimeDisplay = (value) => {
    if (!value && value !== 0) return "";

    // 如果是字符串并且像 "13 hrs" / "2 days" 等，规范化单位
    if (typeof value === "string") {
      const m = value.match(/(\d+(?:\.\d+)?)\s*(\w+)/);
      if (m) {
        const num = parseFloat(m[1]);
        const unit = m[2].toLowerCase();
        if (unit.startsWith("d")) return `${num} 日前`;
        if (unit.startsWith("hr") || unit.startsWith("hour"))
          return `${Math.round(num)} 時間前`;
        if (unit.startsWith("min")) return `${Math.round(num)} 分前`;
        return value;
      }

      // 如果是可解析的日期字符串，转为时间戳继续处理
      const parsed = Date.parse(value);
      if (!Number.isNaN(parsed)) {
        value = parsed;
      } else {
        return value;
      }
    }

    // 处理数值型（秒或毫秒）
    if (typeof value === "number") {
      let ts = value;
      if (ts < 10000000000) ts = ts * 1000; // 秒级转毫秒
      const diffMs = Date.now() - ts;
      const diffMins = Math.floor(diffMs / (1000 * 60));
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      if (diffMins < 60) return `${diffMins} 分前`;
      if (diffHours < 24) return `${diffHours} 時間前`;
      return `${diffDays} 日前`;
    }

    return String(value);
  };

  const normalizeDonationsFromOrders = (orders, campaignData = {}) => {
    if (!Array.isArray(orders)) {
      return [];
    }

    return orders
      .map((order) => {
        // 解析 order.data JSON 字符串
        let parsedData = {};
        if (typeof order?.data === "string") {
          try {
            parsedData = JSON.parse(order.data);
          } catch (e) {
            console.warn("Failed to parse order data:", e);
          }
        }

        // 从 parsedData 或 order 根级别获取金额（兼容不同字段名）
        const rawAmount =
          parsedData?.amount_fast ??
          parsedData?.amount ??
          parsedData?.price ??
          order?.amount ??
          order?.price ??
          0;

        // Use parseNumeric to handle currency strings like "$20.00"
        let amount = parseNumeric(rawAmount);

        // Ensure valid amount
        if (!Number.isFinite(amount) || amount <= 0) {
          return null;
        }

        // Logic that modified amounts based on goal progress has been removed
        // to ensure we display the recorded amount exactly as is.

        // 从 parsedData 获取 firstName + lastName
        const firstName = parsedData?.firstName ?? "";
        const lastName = parsedData?.lastName ?? "";
        const fullName = `${firstName} ${lastName}`.trim();
        const name = fullName || "匿名希望";

        // 从 order 根级别获取 createtime —— 直接使用接口提供的时间，不做随机化/调整
        let timestamp = order?.createtime;

        const daysAgo = calculateDaysAgo(timestamp);

        return {
          name,
          amount: Math.round(amount * 100) / 100, // 保留两位小数
          daysAgo,
        };
      })
      .filter(Boolean);
  };

  useEffect(() => {
    const fetchApiDonations = async () => {
      if (!detailsData?.id) return;
      try {
        const res = await getOrderList(1, detailsData.id);
        let list = res?.data?.data;
        if (!Array.isArray(list)) {
          list = res?.data;
        }
        if (Array.isArray(list) && list.length > 0) {
          const normalized = normalizeDonationsFromOrders(list);
          setApiDonationsList(normalized);

          const total = normalized.reduce(
            (sum, item) => sum + (Number(item.amount) || 0),
            0
          );
          setApiDonationsTotal(total);
        }
      } catch (err) {
        console.error("Failed to fetch order list:", err);
      }
    };
    fetchApiDonations();
  }, [detailsData?.id]);

  //event_id，要去重，一天之内用一个，存cookie
  const getEventId = (eventType) => {
    // 根据事件类型使用不同的cookie名
    const cookieName = `fb_event_id_${eventType}`;

    let storedEventId = Cookies.get(cookieName);
    if (storedEventId) {
      return storedEventId;
    } else {
      // 使用 10 位随机数字作为 event_id
      const newEventId = Math.round(Math.random() * 10000000000).toString();
      Cookies.set(cookieName, newEventId, { expires: 1 }); // 存储1天
      return newEventId;
    }
  };

  const toCheckout = () => {
    const pixel = detailsData.pixel;
    const fbqToken = detailsData.fbq_token;

    // 生成 event_id
    const event_id = getEventId("DonateClick");

    // 构建 eventData
    const eventData = {
      content_ids: ["donation"],
      content_name: "Checkout Page",
      content_category: "Navigation",
      value: 0,
      currency: "jpy",
      num_items: 0,
      contents: [],
    };

    // 调用 addevent (通过 PixelWithEvent)
    PixelWithEvent("DonateClick", event_id);

    // 调用 EventsAll (通过 FacebookAPI.Facebook)
    if (pixel && fbqToken) {
      FacebookAPI.Facebook(fbqToken, pixel, event_id, "DonateClick", eventData);
    }

    // Remove heavy lists from detailsData to avoid history state size limits
    const { supportList, updateList, ...lightDetailsData } = detailsData || {};

    // pass optimized detailsData to checkout via location state
    navigate("/checkout", { state: { detailsData: lightDetailsData } });
  };

  // 处理点击事件，阻止冒泡并调用 toCheckout
  const handleCheckoutClick = (e) => {
    e.stopPropagation();
    toCheckout();
  };

  const renderDonationSpotlight = (key) => (
    <div className="campaign-page__donation-spotlight" key={key}>
      <div className="campaign-page__donation-spotlight-media">
        <img src={DONATION_SPOTLIGHT.image} alt="Hopeful child" />
      </div>
      <div className="campaign-page__donation-spotlight-content">
        <p>{DONATION_SPOTLIGHT.message}</p>
        <button
          type="button"
          className="campaign-page__donation-spotlight-cta"
          onClick={handleCheckoutClick}
        >
          支援する
        </button>
      </div>
    </div>
  );

  const currentDonations =
    (donationsView === "top" ? donationsTop : donationsNewest) || [];

  const donationRows = [];
  currentDonations.forEach((donation, index) => {
    donationRows.push(
      <div
        className="campaign-page__donations-modal-row"
        key={`${donationsView}-${donation.name}-${index}`}
      >
        <div className="campaign-page__donations-avatar campaign-page__donor-svg">
          <img alt="" src={process.env.PUBLIC_URL + "/main/handShare.png"} />
        </div>
        <div className="campaign-page__donations-row-body">
          <div className="campaign-page__donations-row-top">
            <span className="campaign-page__donations-name">
              {donation.name || "匿名希望"}
            </span>
          </div>
          <div className="campaign-page__donations-row-meta">
            <span className="campaign-page__donations-amount">
              {Number(donation.amount).toLocaleString("en", {
                maximumFractionDigits: 0,
              })}円
            </span>

            <span className="campaign-page__donations-separator">·</span>
            <span className="campaign-page__donations-time">
              {computeDonationTime(donation)}
            </span>
          </div>
        </div>
      </div>
    );

    if (index === 3) {
      donationRows.push(
        renderDonationSpotlight(`donation-spotlight-mid-${donationsView}`)
      );
    }
  });

  if (currentDonations.length) {
    donationRows.push(
      renderDonationSpotlight(`donation-spotlight-end-${donationsView}`)
    );
  }

  const campaignUrl = detailsData
    ? getFullDonationUrl(detailsData, BASE_URL)
    : BASE_URL;

  return (
    <div className="campaign-page">
      {/* Copied Toast */}
      {showCopiedToast && (
        <div className="copied-toast">
          <div className="copied-toast__content">
            <span>テキストをコピーしました</span>
            <button
              className="close-btn"
              onClick={() => setShowCopiedToast(false)}
            >
              ×
            </button>
          </div>
        </div>
      )}

      {/* 手机端顶部 */}
      <div className="mobile-nav-header">
        <div
          className={`nav-item ${activeTab === "overview" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("overview");
            setShowFullPage(true);
          }}
        >
          概要
        </div>
        <div
          className={`nav-item ${activeTab === "updates" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("updates");
            setShowFullPage(false);
          }}
        >
          活動報告
          <span className="nav-badge">
            {detailsData?.updateList?.length || 0}
          </span>
        </div>
        <div
          className={`nav-item ${activeTab === "comments" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("comments");
            setShowFullPage(false);
          }}
        >
          応援コメント
          <span className="nav-badge">{supportItems?.length || 0}</span>
        </div>
      </div>

      <div className="campaign-page__content_flex_buju">
        {/* Tags 和 Title - 只在 overview 且 showFullPage 时显示 */}
        {showFullPage && (
          <div className="campaign-page__content_flex_buju_top">
            {/* Tags */}
            <div className="campaign-page__tags">
              <span>#奈良県</span>
              <span>#地域</span>
              <span>#環境保護</span>
              <span>#歴史</span>
              <span>#神社仏閣</span>
              <span>#文化財</span>
            </div>

            {/* Title */}
            <h1 className="campaign-page__title">{title}</h1>

            {/* Creator */}
            <div className="campaign-page__creator">
              <div className="campaign-page__creator-icon">
                {avatar ? (
                  <img
                    src={resolveUrl(avatar)}
                    alt={creator}
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                    }}
                  />
                ) : (
                  <img
                    src="/main-jp/person.jpg"
                    alt={creator}
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                    }}
                  />
                )}
              </div>
              <div className="campaign-page__creator-name">
                {organizerObj.name || creator}
              </div>
            </div>
          </div>
        )}

        {/* Main Content (Left) - 只在 overview 且 showFullPage 时显示 */}
        {showFullPage && (
          <div className="campaign-page__main">
            {/* Carousel */}
            <div className="campaign-page__image-container">
              <div className="campaign-page__image-carousel" ref={carouselRef}>
                {/* Main Slide Display */}
                {HERO_SLIDES.length > 0 && (
                  <div
                    className="campaign-page__image-carousel_inner"
                    onTouchStart={onTouchStart}
                    onTouchMove={onTouchMove}
                    onTouchEnd={onTouchEnd}
                  >
                    <div
                      className="campaign-page__image-track"
                      style={{
                        transform: `translateX(-${currentHeroImage * 100}%)`,
                      }}
                    >
                      {HERO_SLIDES.map((slide, index) => (
                        <div
                          key={index}
                          className="campaign-page__slide-item"
                          style={{ height: "100%", position: "relative" }}
                        >
                          {slide.type === "video" || slide.type === "link" ? (
                            <iframe
                              src={slide.src}
                              title={slide.alt}
                              className="campaign-page__video-iframe"
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                              style={{
                                width: "100%",
                                height: "100%",
                                border: "none",
                              }}
                            />
                          ) : (
                            <img
                              src={slide.src}
                              alt={slide.alt}
                              className="campaign-page__image"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                pointerEvents: "none", // Prevent image drag interfering with swipe
                              }}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Badge Overlay (Hardcoded for demo match) */}
                <div
                  className="campaign-page__badge-overlay"
                  style={{
                    position: "absolute",
                    top: "-10px",
                    left: "-10px",
                    zIndex: 100,
                  }}
                >
                  <svg
                    width={141}
                    height={142}
                    viewBox="0 0 141 142"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M133 8L141 -2.17179e-06L141 8L133 8Z"
                      fill="#AB5C1C"
                    />
                    <path
                      d="M2.18326e-06 141.042L8.0459 133L8.0459 141.042L2.18326e-06 141.042Z"
                      fill="#AB5C1C"
                    />
                    <path
                      d="M0.000701904 73.32L73.3207 2.8525e-05L141.001 0L0.000730429 141L0.000701904 73.32Z"
                      fill="#F88629"
                    />
                    <path
                      d="M43.8003 60.3115L41.5856 62.5262L41.8529 62.1062C41.522 61.9025 41.0128 61.6734 40.5292 61.5207L42.8584 59.1915C43.062 59.6242 43.2784 60.1206 43.4311 60.5279L43.8003 60.3115ZM39.1291 62.9971C39.5873 63.1244 40.1219 63.3535 40.5165 63.5953L38.8364 65.2754L39.9055 66.3446L43.062 63.188L43.6348 63.7608L40.9747 66.4209L42.0183 67.4646L44.6785 64.8045L45.2767 65.4027L42.1074 68.5719L43.202 69.6665L46.3713 66.4973L47.2241 67.3501L48.726 65.8482L47.8732 64.9954L51.1824 61.6861L50.0878 60.5915L46.7786 63.9008L46.1804 63.3026L48.9805 60.5024L47.9368 59.4588L45.1367 62.2589L44.5639 61.6861L47.8477 58.4023L46.7786 57.3332L44.8821 59.2297C44.793 58.7842 44.653 58.2623 44.513 57.6896L44.1184 57.9314L45.8749 56.175L44.7803 55.0803L41.3692 58.4914L40.7201 57.8423L43.3548 55.2076L42.3111 54.1639L39.6764 56.7986L38.9255 56.0477L37.4236 57.5496L38.1745 58.3005L35.6671 60.8079L36.7108 61.8516L39.2182 59.3442L39.8673 59.9933L36.5072 63.3535L37.6018 64.4481L39.2691 62.7807L39.1291 62.9971ZM36.3035 63.3535C35.2853 63.1499 33.567 63.188 32.2815 63.328L31.9887 65.3518C33.3124 65.25 35.0307 65.2881 36.0108 65.5554L36.3035 63.3535ZM38.5564 66.2937L35.6926 69.1574L37.0799 70.5448L38.5054 69.1193L41.2801 71.8939C41.2038 72.8358 41.051 73.8286 40.8728 74.6432L43.0875 75.4323C43.1893 74.2359 43.2275 73.2304 43.2402 72.2249C44.984 72.4412 46.3713 71.7921 47.9496 70.3411C49.566 68.852 52.2389 66.1282 53.7408 64.4736C53.3971 63.9772 52.9134 63.0608 52.7353 62.5262C51.1188 64.4226 48.1532 67.4646 46.5622 68.9283C45.2131 70.1757 43.9657 70.7102 42.6166 70.3539L38.5564 66.2937Z"
                      fill="white"
                    />
                    <path
                      d="M57.0118 46.0817C57.7373 47.4181 58.2592 48.78 58.6155 50.1292C57.3809 49.3273 56.0063 48.3091 54.619 47.1508L58.5519 43.2179L57.05 41.716L55.7263 43.0397L55.6881 41.7797C54.8226 41.8051 53.308 42.1488 52.2516 42.4924L52.2389 44.3125C53.0789 44.1089 54.1226 43.8798 54.9754 43.7907L53.028 45.7381C52.3789 45.1398 51.7425 44.5289 51.1188 43.8798L49.5278 45.4708C50.1642 46.1072 50.8133 46.7054 51.4625 47.3036L46.2695 52.4966L49.986 56.2131C51.6407 57.8678 53.7662 60.1715 54.3262 62.6662C54.8481 62.5007 56.0827 62.3862 56.6427 62.4116C56.1336 59.8151 53.9189 57.0659 52.1116 55.1567L53.7662 53.5021C55.3317 55.144 55.8918 55.8058 55.9427 56.1113C55.9681 56.3404 55.8918 56.4677 55.7136 56.6459C55.5099 56.8495 55.0645 57.2695 54.5681 57.6896C55.179 57.8423 55.93 58.2623 56.4009 58.6823C56.9991 58.1096 57.5464 57.5623 57.8264 57.1805C58.1446 56.735 58.2846 56.3659 58.1955 55.7931C58.1192 55.1313 57.0627 53.9221 54.4281 51.2111C54.2499 51.0329 53.868 50.6256 53.868 50.6256L50.7242 53.7694L49.3624 52.4075L53.0534 48.7164C55.1281 50.4601 57.19 51.962 59.061 52.9675C59.1501 54.533 58.9719 56.1113 58.5265 57.6259C59.1374 57.6005 60.3084 57.6768 60.8684 57.7787C61.1739 56.5059 61.3139 55.2203 61.2884 53.8966C62.8921 54.3803 64.2286 54.3167 65.1195 53.4257C66.3032 52.242 66.2523 51.1729 64.1395 48.5764C63.5667 48.8182 62.7012 49.0218 62.0012 49.0091C63.5285 50.6638 64.0122 51.4529 63.7067 51.7584C63.2994 52.1656 62.3576 52.0384 61.072 51.4911C60.7538 49.3401 60.0283 47.1127 58.8956 44.9362L57.0118 46.0817Z"
                      fill="white"
                    />
                    <path
                      d="M68.9124 41.0796L70.2107 39.7814L66.2014 35.0848L64.3686 33.1247L62.2557 35.2375L64.2158 37.0703L68.9124 41.0796ZM72.9472 43.8161C73.5836 43.1797 73.609 42.2379 72.9472 41.576C72.2726 40.9014 71.3307 40.9269 70.6943 41.5633C70.0579 42.1997 70.0325 43.1415 70.7071 43.8161C71.3689 44.478 72.2981 44.4653 72.9472 43.8161Z"
                      fill="white"
                    />
                  </svg>
                </div>

                {/* Carousel Controls */}
                {HERO_SLIDES.length > 1 && (
                  <div className="campaign-page__carousel-controls">
                    <button
                      className="arrow-btn"
                      onClick={() =>
                        setCurrentHeroImage(
                          (prev) =>
                            (prev - 1 + HERO_SLIDES.length) % HERO_SLIDES.length
                        )
                      }
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M15 18l-6-6 6-6" />
                      </svg>
                    </button>
                    <button
                      className="arrow-btn"
                      onClick={() =>
                        setCurrentHeroImage(
                          (prev) => (prev + 1) % HERO_SLIDES.length
                        )
                      }
                    >
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path d="M9 18l6-6-6-6" />
                      </svg>
                    </button>
                  </div>
                )}
              </div>

              {/* Thumbnails */}
              {HERO_SLIDES.length > 1 && (
                <div className="thumbnails-row">
                  {HERO_SLIDES.map((slide, idx) => (
                    <div
                      key={idx}
                      className={`thumb-item ${
                        currentHeroImage === idx ? "active" : ""
                      }`}
                      onClick={() => setCurrentHeroImage(idx)}
                    >
                      {slide.type === "video" || slide.type === "link" ? (
                        <>
                          <img
                            src={
                              getYouTubeIdFromEmbedUrl(slide.src)
                                ? `https://img.youtube.com/vi/${getYouTubeIdFromEmbedUrl(
                                    slide.src
                                  )}/0.jpg`
                                : slide.src || slide.url
                            }
                            alt={`Thumbnail ${idx}`}
                          />
                          <div className="play-icon">
                            <svg viewBox="0 0 24 24" fill="currentColor">
                              <path d="M8 5v14l11-7z" />
                            </svg>
                          </div>
                        </>
                      ) : (
                        <img src={slide.src} alt={`Thumbnail ${idx}`} />
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* Info Box */}
              <div className="info-box">
                支援募集終了日までに集まった支援金をプロジェクト実行者は受け取ります(All-or-Nothing方式)。支援募集は1月31日（土）午後11:00までです。
              </div>
            </div>
          </div>
        )}

        {showFullPage && (
          <aside className="campaign-page__sidebar">
            {/* Funding */}
            <div className="funding-section">
              <div className="label">支援総額</div>
              <div className="amount-row">
                <div className="current-amount">
                  {formatCurrency(totalRaised).replace("$", "")}円
                </div>
                <div className="goal-amount">
                  目標金額 {formatCurrency(goal).replace("$", "")}円
                </div>
              </div>
              <div className="progress-bar">
                <div
                  className="fill"
                  style={{ width: `${Math.min(progressPercentage, 100)}%` }}
                >
                  <span className="percentage">{progressPercentage}%</span>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="stats-row">
              <div className="stat-item">
                <div className="label">支援者</div>
                <div className="value">{donationsCount}人</div>
              </div>
              <div className="stat-item">
                <div className="label">残り</div>
                <div className="value">{timeLeft || "計算中..."}</div>
              </div>
            </div>

            {/* Cheer Comments */}
            <div className="cheer-comments">
              <h4>応援コメント</h4>
              {supportItems.length > 0 ? (
                supportItems.slice(0, 3).map((item, i) => (
                  <div className="comment-item" key={i}>
                    <div className="avatar">
                      {item.avatar ? (
                        <img alt="" src={resolveUrl(item.avatar)} />
                      ) : (
                        <img alt="" src="/main-jp/person.jpg" />
                      )}
                    </div>
                    <div className="content">
                      <div className="cam_header">
                        <span className="name">{item.name || "匿名希望"}</span>
                        <span className="time">{item.time || "日時不明"}</span>
                      </div>
                      <div className="text">{item.message}</div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="comment-item">
                  <div className="content">
                    <div className="text" style={{ color: "#999" }}>
                      コメントはまだありません。
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Buttons */}
            <div className="action-buttons" onClick={handleCheckoutClick}>
              <button className="donate-btn">プロジェクトの支援にすすむ</button>
              {/* <button className="like-btn">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
            </svg>
            90
          </button> */}
            </div>

            {/* Share */}
            <div className="share-section">
              <div className="url-box">
                <input readOnly value={`${campaignUrl}?ad=share`} />
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(`${campaignUrl}?ad=share`);
                    setShowCopiedToast(true);
                    setTimeout(() => setShowCopiedToast(false), 3000);
                  }}
                >
                  コピー
                </button>
              </div>
              <div className="helper-text">
                専用URLを使うと、あなたのシェアによってこのプロジェクトに何人訪れているかを確認できます
              </div>

              <QuickShareModal
                campaignUrl={campaignUrl}
                detailsData={detailsData}
              />
            </div>
          </aside>
        )}
      </div>

      {/* story-content */}
      <StoryPage
        campaignUrl={campaignUrl}
        detailsData={detailsData}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        showFullPage={showFullPage}
      />

      {/* Sticky Consult Button - 只在 overview 时显示 */}
      {activeTab === "overview" && (
        <div className="sticky-consult-btn">
          <div className="arrow-icon">&gt;</div>
          プロジェクトの相談をする
        </div>
      )}

      {/* Mobile Sticky Footer */}
      {activeTab === "overview" && (
        <div className="mobile-sticky-footer">
          <div className="footer-action-row">
            <button className="footer-donate-btn" onClick={handleCheckoutClick}>
              プロジェクトの支援にすすむ
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CampaignPage;
